import { default as initAuthStore } from './auth'

export const initStores = (props) => {
  return {
    AuthStore: initAuthStore(props),
  }
}